import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import busBodyworkBasicInformationPropTypes from '../proptypes/BusBodyworkPropTypes';

const BusBodyworkBasicInformationResource = ({
  make, model, year, fuelCapacity
}) => (
  <>
    <ResourceProperty label="Marca:">{make}</ResourceProperty>
    <ResourceProperty label="Modelo:">
      {model || '-'}
    </ResourceProperty>
    <ResourceProperty label="Año:">
      {year || '-'}
    </ResourceProperty>
    <ResourceProperty label="Capacidad de Combustible (gal):">
      {fuelCapacity || '-'}
    </ResourceProperty>
  </>
);

BusBodyworkBasicInformationResource.propTypes = busBodyworkBasicInformationPropTypes;

export default BusBodyworkBasicInformationResource;
